<ng-container *ngTemplateOutlet="SearchResults"></ng-container>
@if (limitSearch && !noSearchResults) {
  <p class="limitedSearch">{{ 'SearchResultLimited' | translate }}</p>
}
@if (noSearchResults) {
  <p class="noResultFound" >
    {{ 'NoSearchResultsFound' | translate }}
  </p>
}

<ng-template #SearchResults>
  <!-- SEARCH MENUITEMS RESULTS SECTIONS -->
  @for (webAppSpec of webAppSpecsWithSearchResults; track webAppSpec) {
    <div #searchMenuHeader
         class="accordion-header"
         id="ApplicationSearchResults_{{webAppSpec.webAppName}}"
    >
      <svg soho-icon icon="roles"></svg>
      <a href="#"
         attr.data-automation-id="lm-{{webAppSpec.webAppName}}-searchresults"
         id="{{webAppSpec.webAppName}}SearchResults"
      >
        <span>{{webAppSpec.webAppTitle}}</span>
      </a>
    </div>

    @if (menuSearchResultsByWebApp [ webAppSpec.webAppName ].length > 0) {
      <div class="accordion-pane">
        @for (menuSearchResult of menuSearchResultsByWebApp [ webAppSpec.webAppName ]; track menuSearchResult) {
          @if (menuSearchResult.menu) {
            <div #accordionHeader class="accordion-header">
              <button class="btn" type="button">
                <span class="icon plus-minus" aria-hidden="true" role="presentation"></span>
              </button>
              <a href="#"
                 attr.data-automation-id="{{dataAutomationId(menuSearchResult)}}"
                 attr.id="{{menuSearchResult.id}}_searchresult"
                 (click)="onMenuItemClicked(menuSearchResult)"
              >
                <span class="accordion-search-span-heading">{{menuSearchResult.child}}</span>
                @if (menuSearchResult.parent) {
                  <br>
                  <span class="accordion-search-span-subheading">{{menuSearchResult.parent}}</span>
                }
              </a>
            </div>
            <lm-application-menu-submenu
              class="accordion-pane has-icons"
              [inSearchResultsMenu]="true"
              [menuItemSpecs]="menuSearchResult?.menu"
              (menuLoaded)="onMenuLoaded($event)"
            ></lm-application-menu-submenu>
          }
        }

        @for (menuSearchResult of menuSearchResultsByWebApp [ webAppSpec.webAppName ]; track menuSearchResult) {
          @if (!menuSearchResult.menu) {
            <div class="accordion-header">
              <a href="#"
                 attr.data-automation-id="{{dataAutomationId(menuSearchResult)}}"
                 attr.id="{{menuSearchResult.id}}_searchresult"
                 attr.searchMenuUrl="{{menuSearchResult.url}}"
                 (click)="openSearchMenuItem($event)"
              >
                <span class="accordion-search-span-heading">{{menuSearchResult.child}}</span>
                @if (menuSearchResult.parent) {
                  <br>
                  <span class="accordion-search-span-subheading">{{menuSearchResult.parent}}</span>
                }
              </a>
            </div>
          }
        }
      </div>
    }
  }

  <!-- SYSTEM RESULTS SECTIONS -->
  @if (systemSearchResults.length > 0) {
    <div #searchMenuHeader class="accordion-header">
      <svg soho-icon icon="bullet-list"></svg>
      <a href="#" id="SystemSearchResults" data-automation-id="lm-System-searchresults"><span>{{systemTitle}}</span></a>
    </div>
  }
  @if (systemSearchResults.length > 0) {
    <div class="accordion-pane">
      @for (systemSearchResult of systemSearchResults; track systemSearchResult) {
        <div class="accordion-header">
          <a href="#"
             attr.data-automation-id="{{systemSearchResult.automationId}}-searchresult"
             attr.id="System_{{systemSearchResult.id}}_searchresult"
             attr.searchMenuUrl="{{systemSearchResult.url}}"
             (click)="systemMenuItemClick(systemSearchResult)"
          >
            <span class="accordion-search-span-heading">{{systemSearchResult.child}}</span><br>
          </a>
        </div>
      }
    </div>
  }

  <!-- SEARCH REPORTS RESULTS SECTIONS -->
  @if (reportSearchResults.length > 0) {
    <div #searchMenuHeader class="accordion-header">
      <svg soho-icon icon="bar"></svg>
      <a href="#" id="ReportsSearchResults" data-automation-id="lm-Reports-searchresults"><span>{{reportTitle}}</span></a>
    </div>
  }
  @if (reportSearchResults.length > 0) {
    <div class="accordion-pane">
      @for (reportSearchResult of reportSearchResults; track reportSearchResult) {
        <div class="accordion-header">
          <a href="#"
             attr.data-automation-id="lm-Report-{{reportSearchResult.automationId}}-searchresult"
             attr.id="Report_{{reportSearchResult.id}}_searchresult"
             attr.searchMenuUrl="{{reportSearchResult.url}}"
             (click)="openReportSearchItem(reportSearchResult)"
          >
            <span class="accordion-search-span-heading">{{reportSearchResult.child}}</span><br>
            <span class="accordion-search-span-subheading">{{reportSearchResult.parent}}</span>
          </a>
        </div>
      }
    </div>
  }

  <!-- SEARCH DATA RESULTS SECTIONS -->
  @if (dataSearchResults.length > 0) {
    <div #searchMenuHeader class="accordion-header">
      <svg soho-icon icon="folder"></svg>
      <a href="#" id="DataSearchResults" data-automation-id="lm-Data-searchresults"><span>{{dataTitle}}</span></a>
    </div>
  }
  @if (dataSearchResults.length > 0) {
    <div class="accordion-pane">
      @for (dataSearchResult of dataSearchResults; track dataSearchResult) {
        <div class="accordion-header">
          <a href="#"
             attr.data-automation-id="{{dataAutomationId(dataSearchResult)}}"
             attr.id="{{dataSearchResult.id}}_searchresult"
             attr.resourceId="{{dataSearchResult.resourceId}}"
             attr.searchMenuUrl="{{dataSearchResult.url}}"
             (click)="openSearchItemLink($event)"
          >
            <span class="accordion-search-span-heading">{{dataSearchResult.child}}</span><br>
            <span class="accordion-search-span-subheading">{{dataSearchResult.parent}}</span>
          </a>
        </div>
      }
    </div>
  }
</ng-template>

<div #menuFormDialog>
  <!-- dialog placeholder used to display action form from menu -->
</div>

<!--Accessibility: ARIA live region-->
<div class="audible" aria-hidden="true" aria-live="polite">
  {{ accessibility.announcement }}
</div>